import { __assign, __extends } from "tslib";
import React from 'react';
import { Component } from 'react';
import { ErrorContent } from '../error-content/error-content';
import { Banner } from '../banners/banner';
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.props = props;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        // Update state so the next render will show the fallback UI
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        // eslint-disable-next-line no-console
        console.error({ errorBoundary: { error: error, info: info } });
    };
    ErrorBoundary.prototype.render = function () {
        var _a = this.props, fallback = _a.fallback, children = _a.children, errorLevel = _a.errorLevel, errorDescription = _a.errorDescription, errorTitle = _a.errorTitle;
        var hasError = this.state.hasError;
        if (!hasError)
            return children;
        if (errorLevel === 'page') {
            return React.createElement(ErrorContent, null);
        }
        if (fallback) {
            return fallback;
        }
        // by default return component error level
        var title = errorTitle !== null && errorTitle !== void 0 ? errorTitle : 'Technical error';
        var description = errorDescription !== null && errorDescription !== void 0 ? errorDescription : 'Something went wrong. Please try again later.';
        return (React.createElement(Banner, __assign({ type: "in-panel", variation: "error", title: title }, this.props), description));
    };
    return ErrorBoundary;
}(Component));
export { ErrorBoundary };
